
<template>
  <the-1-column-layout v-if="complaint">
    <h3>{{loc('status')}}: {{complaint.status.name}}</h3>
    <p><strong>{{loc('complaintId')}}</strong>: {{complaint.uuid}}</p>
    <p>
      <strong>{{loc('serialNumber')}}</strong>: <router-link :to="{ name: 'customer-machine', params: { serialNumber: complaint.serialNumber }}">{{complaint.serialNumber}}</router-link><br>
      <strong>{{loc('deliveryDateComplaint')}}</strong>: {{complaint.deliveryDate}}
    </p>
    <div class="box no-inner-margin" v-if="complaint.compensation">
      <h3>{{loc('compensation')}}</h3>
      <p v-html="compensationHtml"></p>
    </div>
    <v-complaint-user-info v-if="complaint.user" :user-data="complaint.user" :company-data="complaint.company"></v-complaint-user-info>
    <p v-else>{{loc('userNotFoundExplanation')}}</p>

    <h3>{{loc('forms.labels.complaintDescription')}}:</h3>
    <div v-html="descriptionHtml"></div>


    <h3>{{loc('forms.labels.complaintAccessories')}}:</h3>
    <div v-if="complaint.accessoriesText" v-html="accessoriesHtml"></div>
    <v-data-items v-else :edit-mode="false" :hide-empty="accessoriesData.hideEmpty" :multiplyField="'amount'" :sum-field="accessoriesData.sumField" :fields="accessoriesData.fields" :data="complaint.accessories" :display-only="true"></v-data-items>

    <h3>{{loc('forms.labels.complaintJobs')}}:</h3>
    <div v-if="complaint.jobsText" v-html="jobsHtml"></div>
    <v-data-items v-else :edit-mode="false" :hide-empty="servicesData.hideEmpty" :sum-field="servicesData.sumField" :fields="servicesData.fields" :data="complaint.services" :display-only="true"></v-data-items>
    <div v-if="totalAmount">{{loc('allInTotal')}}: <v-currency-input :display-only="true" :value="totalAmount" :decimal-char="','" ></v-currency-input></div>

    <h3>{{loc('files')}}:</h3>
    <div v-if="complaint.files.length">
      <div  v-for="file in complaint.files" v-bind:key="file.url"><a :href="file.url" target="_blank">{{file.name}}</a></div>
    </div>
    <p v-else>{{loc('noFiles')}}</p>

    <p class="d-print-none"><br /><a href="#" v-on:click="print">{{loc('printDocument')}}</a></p>
  </the-1-column-layout>
</template>

<script>

import VComplaintUserInfo from './v-complaint-user-info.vue';
import VDataItems from './v-data-items.vue';

export default {
  name: 'ViewComplaint',
  components: {
    'v-complaint-user-info': VComplaintUserInfo,
    'v-data-items': VDataItems
  },
  data: function () {
    return {
      complaintId: null
    }
  },
  computed: {
    jobsHtml() {
      return this.textToHtml(this.complaint.jobsText);
    },
    accessoriesHtml() {
      return this.textToHtml(this.complaint.accessoriesText);
    },
    compensationHtml() {
      return this.textToHtml(this.complaint.compensation);
    },
    descriptionHtml() {
      return this.textToHtml(this.complaint.description);
    },
    complaint() {
      return this.$store.state.complaints.filter(complaint => complaint.uuid === this.complaintId)[0];
    },
    accessoriesData() {
      return {
        sumField: 'price',
        hideEmpty: true,
        value: [],
        fields: [{
          label: this.loc('complaintAccessories.name'),
          placeholder: this.loc('complaintAccessories.name'),
          type: 'text',
          name: 'name'
        }, {
          label: this.loc('complaintAccessories.id'),
          placeholder: this.loc('complaintAccessories.id'),
          type: 'text',
          name: 'id'
        }, {
          label: this.loc('complaintAccessories.amount'),
          placeholder: this.loc('complaintAccessories.amount'),
          type: 'number',
          name: 'amount'
        }, {
          label: this.loc('complaintAccessories.price'),
          placeholder: this.loc('complaintAccessories.price'),
          type: 'currency',
          name: 'price'
        }]
      }
    },
    servicesData() {
      return {
        sumField: 'price',
        hideEmpty: true,
        value: [],
        fields: [{
          label: this.loc('complaintServices.name'),
          placeholder: this.loc('complaintServices.name'),
          type: 'text',
          name: 'name'
        }, {
          label: this.loc('complaintServices.hours'),
          placeholder: this.loc('complaintServices.hours'),
          type: 'number',
          name: 'hours'
        }, {
          label: this.loc('complaintServices.price'),
          placeholder: this.loc('complaintServices.price'),
          type: 'currency',
          name: 'price'
        }]
      }
    },
    totalAmount: function () {
      var sum = 0;

      //gotta get complaint data
      // let complaint = this.$store.state.complaints.filter(complaint => complaint.uuid === this.complaintId)[0];

      //sum of accessories
      this.complaint.accessories.forEach(e => {
        sum += e.amount * e.price;
      });

      //sum of services
      this.complaint.services.forEach(e => {
         sum += e.hours * e.price;
      });

      return sum
    }
  },
  methods: {
    textToHtml(text) {
      let htmlText = '';

      // Strip \r
      const stripped = text.replace(/\r/g, '');

      // Split into paragraphs
      const paragraphs = stripped.split('\n\n');

      paragraphs.forEach(paragraph => {
        htmlText += '<p>';
        // Replace single linefeeds with <br>
        htmlText += paragraph.replace(/\n/g, '<br>');
        htmlText += '</p>';
      });

      return htmlText;
    },
    print(e) {
      e.preventDefault();
      window.print();
    }
  },
  mounted() {
    // Check if we have param /company/:id and use that else use logged in user's company as default
    this.complaintId = this.$route.params.id

    this.$store.dispatch('getComplaint', this.complaintId);
  }
}

</script>
